<template lang="pug">
.container-intro
  .conteudo-intro
    .titulo Destaque-se em um mundo competitivo
    .typing-container
      .titulo-principal(ref="titulo")
    .area-botoes
      Button(
        size="large"
        width="160px"
        @click="$router.push('/login')"
      ) Acesse
      Button(
        variant="primary"
        size="large"
        width="160px"
        @click="$router.push('/cadastrar')"
        colorHover="#000"
      ) Cadastre-se
</template>

<script>
import Button from '@/components/ui/Button.vue'

export default {
  components: {
    Button
  },

  data() {
    return {
      texto: "Seja Visto, Seja nexa",
      atraso: 50,
      contadorDeLetras: 0,
      escreverTimeout: null,
      iniciado: false
    }
  },

  mounted() {
    this.iniciado = true
    this.escreverTimeout = setTimeout(() => {
      this.escreverTexto()
    }, 800)
  },

  beforeDestroy() {
    this.iniciado = false
    clearTimeout(this.escreverTimeout)
  },

  methods: {
    escreverTexto() {
      const el = this.$refs.titulo
      if (!this.iniciado || !el) return // Evita erro se componente foi destruído

      if (this.contadorDeLetras < this.texto.length) {
        el.textContent += this.texto.charAt(this.contadorDeLetras)
        this.contadorDeLetras++
        this.escreverTimeout = setTimeout(this.escreverTexto, this.atraso)
      }
    }
  }
}
</script>

<style lang="scss">
.container-intro{
  position: relative;
  height: 100%;
  width: 100%;
  color: #fff;
  
  .conteudo-intro{
    max-width: 550px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .titulo{
      font-size: 16px;
      text-align: center;
    }

    .typing-container {
      margin: 25px 0;

      .titulo-principal {
        text-align: center;
        font-size: 48px;
        font-weight: bold;
        min-height: 60px;
      }
      
      
      .titulo-principal::after {
        content: "_";
        animation: piscar 1s infinite;
        padding-left: 25px;
        color: rgb(77 124 15);
        font-size: 31px;
      }

      @keyframes piscar {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }

      @media screen and (max-width: 600px) {
        .titulo-principal {
          font-size: 25px;
        
          &::after {
            padding-left: 10px;
            font-size: 20px;
          }
        }
      }
    }
    .area-botoes{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>